// Encapsulate code in Immediately Invoked Functional Expression
(function () {
  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {
    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function () {
      ui.root = dom(".popup");

      if (!ui.root) {
        return;
      }

      // Get UI element references
      ui.close = dom(".popup-close", ui.root);

      
      if (ui.root.classList.contains("popup-overlay")) {
        const timeout = window.parseInt(ui.root.dataset.timeout, 10);
        // Show the popup after delay
        window.setTimeout(() => {
          ui.root.classList.add("active");
        }, timeout * 1000);
      } else {
        // Move the popup to the top of the page, if it is present
        document.body.insertBefore(ui.root, document.body.firstChild);
        // Show the popup now that it has been placed to avoid seeing it shift
        ui.root.classList.add("active");
      }

      // Handle closing the popup
      ui.close.onclick = function (event) {
        event.preventDefault();
        ui.root.classList.remove("active");
        // TODO: Cache this closing of the popup?
      };
    },
  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));
})();
